import { VelvetCommonContent } from "../VelvetCommonContent/VelvetCommonContent";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="relative grid min-w-0 overflow-hidden border-b border-parchment/20 bg-ink md:min-h-[calc(100svh-6rem)] md:grid-cols-12 md:items-stretch">
    <VelvetMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="velvet-arch order-2 mx-5 min-h-72 min-w-0 w-auto border border-parchment/20 md:col-span-6 md:col-start-7 md:m-8 md:ml-10 md:h-auto"
      imageClassName="h-full object-cover saturate-[0.75] transition-[filter,transform] duration-500 ease-out hover:scale-[1.02] hover:saturate-100"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <VelvetCommonContent
      alignment={alignment}
      buttons={buttons}
      className="order-1 min-w-0 justify-center px-6 py-12 md:col-span-6 md:col-start-1 md:border-r md:border-parchment/15 md:px-10 md:py-16 lg:px-[max(4rem,calc((100vw-82rem)/2))]"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="text-5xl md:text-8xl lg:text-[6rem]"
      tone="dark"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
